var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.trigger.deleted
    ? _c(
        "div",
        {
          staticClass:
            "row align-items-center slide-up trigger-criteria-wrapper mb-2",
        },
        [
          _c("div", { staticClass: "col-md-10 col-12" }, [
            _c(
              "div",
              { staticClass: "row no-gutters" },
              [
                _c("p", { staticClass: "mt-3" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("global.words.when")) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-auto" },
                  [
                    _c(
                      "b-dropdown",
                      {
                        staticClass: "m-md-2",
                        attrs: {
                          id: "dropdown-1",
                          text: _vm.triggersDropdownText,
                          "toggle-class": "text-decoration-none p-0",
                          "no-caret": "",
                          variant: "link",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "button-content",
                              fn: function () {
                                return [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-sm dropdown-toggle clickable trigger--client-profile-status-changed",
                                      class: _vm.triggerSelected
                                        ? "text-white"
                                        : "text-dark",
                                      style: _vm.triggersDropdownStyle,
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.triggersDropdownText) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          508912877
                        ),
                      },
                      [
                        _vm._v(" "),
                        _vm._l(_vm.triggersToUse, function (trig) {
                          return _c(
                            "b-dropdown-item",
                            {
                              key: trig.key,
                              on: {
                                click: function ($event) {
                                  return _vm.handleTriggerClick(trig)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(trig.name) +
                                  "\n          "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.args, function (argument) {
                  return _c(
                    "div",
                    { key: argument.id, staticClass: "col-auto slide-up" },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-row align-items-center" },
                        [
                          _c("div", { staticClass: "label argument" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(argument.name) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-dropdown",
                            {
                              staticClass: "m-md-2",
                              attrs: {
                                "toggle-class": "text-decoration-none p-0",
                                "no-caret": "",
                                variant: "link",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "button-content",
                                    fn: function () {
                                      return [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "btn btn-sm dropdown-toggle bg-light text-dark font-weight-bold",
                                            class: {
                                              "dropdown-error":
                                                _vm.argumentError(argument),
                                            },
                                            style: _vm.triggersDropdownStyle,
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.argumentDropdownText(
                                                    argument
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _vm._v(" "),
                              _vm._l(
                                _vm.argumentValues(argument),
                                function (value) {
                                  return _c(
                                    "b-dropdown-item",
                                    {
                                      key: value.value,
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleArgumentClick(
                                            value,
                                            argument
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(value.name) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "position-absolute pr-4",
              staticStyle: { right: "0" },
            },
            [
              _c(
                "inline-prompt",
                {
                  staticClass: "clickable",
                  staticStyle: { "font-size": "0.8rem" },
                  attrs: {
                    "action-type": "delete",
                    placement: "left",
                    "confirmation-text": "i18n|global.actions.confirmDelete",
                  },
                  on: { accept: _vm.handleDelete },
                },
                [_c("i", { staticClass: "fa fa-trash text-danger" })]
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }